export default "__VITE_PUBLIC_ASSET__9a20ea84__"